import cx from 'classnames';
import type { FunctionComponent } from 'react';

import { RouterLink } from '../Link';

import { useSubnavContext } from './context';

import styles from './Subnav.module.less';

export type SubnavItemProps = {
  to: string;
  navKey?: string;
  openInNewTab?: boolean;
  testId?: string;
};

/**
 * Represents a single item in the Subnav.
 */
const SubnavItem: FunctionComponent<SubnavItemProps> = ({ to, children, navKey, openInNewTab, testId }) => {
  const { activeKey } = useSubnavContext();

  return (
    <RouterLink
      to={to}
      className={cx(styles.link, {
        [styles.linkActive]: activeKey && activeKey === navKey,
      })}
      openInNewTab={openInNewTab}
      tabIndex={0} // Doing this to make the link focusable
      testId={testId}
    >
      <div
        id={`fossa-subnav-${navKey}`}
        className={styles.item}
      >
        {children}
      </div>
    </RouterLink>
  );
};

export default SubnavItem;
